import { render, staticRenderFns } from "./OngletAlerte.vue?vue&type=template&id=56275066"
import script from "./OngletAlerte.vue?vue&type=script&lang=js"
export * from "./OngletAlerte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports